import { Component } from '@angular/core';
import { ServiciosRiegosService } from "../../../services/riesgo-liquidez/servicios-riegos.service";
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../../services/data/data.service';
import { gap, cuentas, varTemp, cuentasProm, varTempProm, varProm, opciones, GAPRiesgos } from '../tablaslds';
import { messages } from '../../funciones/mensajes';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import moment from 'moment';
import { FiltersM } from '../../../components/models';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { FormaterNumberPipe } from '../../../services/pipes/formater-number.pipe';

@Component({
  selector: 'app-gap',
  templateUrl: './gap.component.html',
  styleUrl: './gap.component.css',
  providers: [FormaterNumberPipe]
})
export class GapComponent {
  Filters = FiltersM
  /* Evaluaciones */
  private numEvaluaciones = 1;
  /*Obtención de datos consultas*/
  public idPlantilla: number;
  private idInst;
  private idAdmin: string;
  public moneda: string;
  private periodosSeleccionados = 0;
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitlesGraf = '';
  /*Variables filtros*/
  public periodos = [];
  public cadenaEvaluacion = [];
  /* Variables de tabla */
  public bandas = ['encabezado1Tabla1','encabezado2Tabla1','encabezado3Tabla1','encabezado4Tabla1','encabezado5Tabla1','encabezado6Tabla1',
  'encabezado7Tabla1','encabezado8Tabla1'];
  public tablasExpand = [false,false,false,false,false,false,false,false,true,false,true]
  public bandasValues = []; //= [0,0,0,0,0,0,0,0];
  public totalPorcen = '0';
  public idEdit;
  private nameVar:string;
  public dataOrdenado = [];
  public dataOrdenadoComp = [];
  private dataAllCuentas = [];
  private dataAllPromedio = [];
  public maximoIng = 90;
  public porMax = 100;
  public capAco = false;
  edit = false;
  public tituloEdit = '';
  private adicionales = []

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';

  public modal = false;
  /* Variables de consultas */
  public skeleton = new Array(16);
  public skeletonColums = new Array(6);
  constructor(
    private service: ServiciosRiegosService,
    private translate: TranslateService,
    public dataService: DataService,
    private cookieService: CookieService,
    private excelService: ExcelService,
    private formaterPipe: FormaterNumberPipe,
  ) {
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    if (instAT ) {
      this.idPlantilla = Number(instAT.idPlantilla);
      this.moneda = companiesRiesgoLiquidez.find(c => c.id === this.idInst).moneda;
      this.getEvaluaciones();
    } else {
      setTimeout(() => {
        var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.idInst)).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }, 500)
    }
  }
  /* Consultas */
  private async getEvaluaciones(){
    const data = await this.service.getEvaluaciones(this.idPlantilla);
    this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
  }
    /* Ordenamiento */
  private ordenamientoDataEvaluacion(array: any){
    const info = CommonVariables.obtenerPeriodos(array, this.numEvaluaciones);
    this.periodos = info.periodos;
    this.periodosSeleccionados = info.perSel;
    for(const an of this.periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();
  }
    /*Obtención de datos*/
  /* Obtener la cadena de evaluación */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot=0;
    for(var i = this.periodos.length-1; i>=0; i--){
      for(var j = this.periodos[i].series.length-1; j>=0; j--){
        if(this.periodos[i].series[j].check){
          this.cadenaEvaluacion.push({
            evaluacion: this.periodos[i].series[j].periodo,
            idEvaluacion: this.periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.periodos[i].series[j].pos,
            an: this.periodos[i].series[j].an,
            mes: this.periodos[i].series[j].mes,
            mesNum: this.periodos[i].series[j].nmes,
          });
          tot++;
          if(tot>this.numEvaluaciones){
            break;
          }
        }
      }
      if(tot>this.numEvaluaciones){
        break;
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.idPlantilla === 7 ? this.getDataPromedios() : this.getDatosAT();
  }
  private async getDatosAT(){
    const cuentasAT = GAPRiesgos.cuentasAT(this.idPlantilla);
    if(Object.keys(cuentasAT).length == 0){
      var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.idInst)).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }else{
      var datos = [];
      await this.agregarACuentasTotal(
        cuentasAT['cuentas'],
        this.cadenaEvaluacion[0].idEvaluacion,
        this.service.getDetalleCuenta.bind(this.service),
        'detalleEvaluacionCuenta',
        'idCuenta',
        datos
      );

      await this.agregarACuentasTotal(
        cuentasAT['varTemp'],
        this.cadenaEvaluacion[0].idEvaluacion,
        this.service.getDetalleVarTemp.bind(this.service),
        'detalleEvaluacionVarTemp',
        'idVarTemp',
        datos
      );

      await this.agregarACuentasTotal(
        cuentasAT['var'],
        this.cadenaEvaluacion[0].idEvaluacion,
        this.service.getVariable.bind(this.service),
        'detalleEvaluacionVariable',
        'idVariable',
        datos
      );
      this.getDatosGAPRiesgos(datos);
    }
  }  
  private async agregarACuentasTotal<T>(cuentas: string[],idEvaluacion: number,servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal:any[]) {
    const promesas = cuentas.map(id =>
      servicio(idEvaluacion, id)
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal.push({
        id: detalle[idKey],
        valor: detalle.valor,
        idEvaluacion,
        descripcion: detalle.descripcion,
        anio: this.cadenaEvaluacion[0].an,
        mes: this.cadenaEvaluacion[0].mesNum
      });
    });
  }
  private async getDatosGAPRiesgos(datos){
    try{
      const dgap = await this.service.getGAPRiesgos(this.idAdmin, this.cadenaEvaluacion[0].mesNum, this.cadenaEvaluacion[0].an);
      this.bandas = dgap[0]?.bandas.map(b => b.label);
      dgap.map(item => (
        datos.push({
        id: item.name,
        mes: item.mes,
        anio: item.anio,
        idEvaluacion: this.cadenaEvaluacion[0].idEvaluacion,
        bandas: item.bandas.map((banda: any) => banda.valor)
      })));
      this.getDataTabla(datos);
      this.getDataTablaComp(datos);
    }catch(e){
      messages.errorMessageGraph(e);
    }
  }
  private getDataPromedios(){
    var val = [], periodos = 0;
    for(var an=this.periodos.length-1; an>=0;an--){
      for(var mes=this.periodos[an].series.length-1; mes>=0; mes--){
        if(this.periodos[an].series[mes].check || (periodos !== 0 && periodos < 3)){
          val.push(this.periodos[an].series[mes]);
          periodos++;
        }
      }
    }
    this.getPromQueryCuentas(val);
  }
  private async getPromQueryCuentas(arreglo){
    var variables;
    let datos = [];
    for(const val of cuentasProm){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idCuenta: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idCuenta: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idCuenta: val, 
          }
        break;
      }
      const data = await this.service.getCuentasPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idCuenta,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
    }
    this.getPromQueryVarTemp(arreglo, datos);
  }
  private async getPromQueryVarTemp(arreglo, datos){
    var variables;
    for(const val of varTempProm){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idVarTemp: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idVarTemp: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idVarTemp: val, 
          }
        break;
      }
      const data = await this.service.getVarTempPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idVarTemp,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
    }
    this.getPromQueryVar(arreglo, datos)
  }
  private async getPromQueryVar(arreglo, datos){
    var variables;
    let i=0;
    for(const val of varProm){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idVariable: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idVariable: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idVariable: val, 
          }
        break;
      }
      const data = await this.service.getVarPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idVariable,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
    }
    this.dataAllPromedio=datos;
    this.getDataCuentas();
  }
  private async getDataCuentas(){
    var eva = this.cadenaEvaluacion[0].idEvaluacion;
    let datos = [];
    for(const val of cuentas){
      const data = await this.service.getDetalleCuenta(eva, val);
      datos.push({
        id: data.detalleEvaluacionCuenta.idCuenta,
        valor: data.detalleEvaluacionCuenta.valor,
        idEvaluacion: data.detalleEvaluacionCuenta.idEvaluacion,
        descripcion: '',
      });
    }
    this.getCuentas(datos, eva);
  }
  private async getCuentas(datos, eva){
    for(const val of cuentas){
      const data = await this.service.getCuenta(val, this.idPlantilla)
      var dat = datos.filter(dat => dat.id === data.cuenta.id)[0];
      dat.descripcion = data.cuenta.descripcion;
    }
    this.getDataVarTemp(datos, eva);

  }
  private async getDataVarTemp(datos, eva){
    for(const val of varTemp){
      const data = await this.service.getDetalleVarTemp(eva, val); 
      datos.push({
        id: data.detalleEvaluacionVarTemp.idVarTemp,
        valor: data.detalleEvaluacionVarTemp.valor,
        idEvaluacion: data.detalleEvaluacionVarTemp.idEvaluacion,
        descripcion: '',
      });
    }
    this.getVarTemp(datos, eva);
  }
  private async getVarTemp(datos, eva){
    for(const val of varTemp){
      const data = await this.service.getVarTemp(val, this.idPlantilla);
      var dat = datos.filter(dat => dat.id === data.varTemp.id)[0];
      dat.descripcion = data.varTemp.descripcion;
    }
    this.getDataAhorros(datos, eva);
  }
  private async getDataAhorros(datos, eva){
    const data = await this.service.getAhorros(this.cadenaEvaluacion[0].an+'-'+FuncionesMes.f_switchmes3(this.cadenaEvaluacion[0].mes)+'-01');
    datos.push({
      id: 'AHO_02',
      idEvaluacion: eva,
      bandas: [ data.ahorros_sub_calculos['AHO_02'].de_1_7,
      data.ahorros_sub_calculos['AHO_02'].de_8_15,
      data.ahorros_sub_calculos['AHO_02'].de_16_30,
      data.ahorros_sub_calculos['AHO_02'].de_31_60,
      data.ahorros_sub_calculos['AHO_02'].de_61_90,
      data.ahorros_sub_calculos['AHO_02'].de_91_180,
      data.ahorros_sub_calculos['AHO_02'].de_181_360,
      data.ahorros_sub_calculos['AHO_02'].mas_360,]
    },{
      id: 'AHO_09',
      idEvaluacion: eva,
      bandas: [data.ahorros_sub_calculos['AHO_09'].de_1_7,
      data.ahorros_sub_calculos['AHO_09'].de_8_15,
      data.ahorros_sub_calculos['AHO_09'].de_16_30,
      data.ahorros_sub_calculos['AHO_09'].de_31_60,
      data.ahorros_sub_calculos['AHO_09'].de_61_90,
      data.ahorros_sub_calculos['AHO_09'].de_91_180,
      data.ahorros_sub_calculos['AHO_09'].de_181_360,
      data.ahorros_sub_calculos['AHO_09'].mas_360,]
    },{
      id: 'AHO_03',
      idEvaluacion: eva,
      bandas: [(data.ahorros_sub_calculos['AHO_03']/30)*7,
      (data.ahorros_sub_calculos['AHO_03']/30)*8,
      (data.ahorros_sub_calculos['AHO_03']/30)*15,
      data.ahorros_sub_calculos['AHO_03'],
      data.ahorros_sub_calculos['AHO_03'],
      (data.ahorros_sub_calculos['AHO_03']/30)*90,
      (data.ahorros_sub_calculos['AHO_03']/30)*180,
      (data.ahorros_sub_calculos['AHO_03']/30)*360,]
    },{
      id: 'AHO_04',
      idEvaluacion: eva,
      bandas: [(data.ahorros_sub_calculos['AHO_04']/30)*7,
      (data.ahorros_sub_calculos['AHO_04']/30)*8,
      (data.ahorros_sub_calculos['AHO_04']/30)*15,
      data.ahorros_sub_calculos['AHO_04'],
      data.ahorros_sub_calculos['AHO_04'],
      (data.ahorros_sub_calculos['AHO_04']/30)*90,
      (data.ahorros_sub_calculos['AHO_04']/30)*180,
      (data.ahorros_sub_calculos['AHO_04']/30)*360,]
    },{
      id: 'AHO_05',
      idEvaluacion: eva,
      bandas: [(data.ahorros_sub_calculos['AHO_05']/30)*7,
      (data.ahorros_sub_calculos['AHO_05']/30)*8,
      (data.ahorros_sub_calculos['AHO_05']/30)*15,
      data.ahorros_sub_calculos['AHO_05'],
      data.ahorros_sub_calculos['AHO_05'],
      (data.ahorros_sub_calculos['AHO_05']/30)*90,
      (data.ahorros_sub_calculos['AHO_05']/30)*180,
      (data.ahorros_sub_calculos['AHO_05']/30)*360,]
    });
    this.getDataAmortizacion(datos, eva);
  }
  private async getDataAmortizacion(datos, eva){
    const data = await this.service.getAmortizacion(this.cadenaEvaluacion[0].an+'-'+FuncionesMes.f_switchmes3(this.cadenaEvaluacion[0].mes)+'-01');
    datos.push({
      id: 'LIQ_01',
      idEvaluacion: eva,
      bandas: [ data.liquidaciones_sub_calculos['LIQ_01'].de_1_7,
      data.liquidaciones_sub_calculos['LIQ_01'].de_8_15,
      data.liquidaciones_sub_calculos['LIQ_01'].de_16_30,
      data.liquidaciones_sub_calculos['LIQ_01'].de_31_60,
      data.liquidaciones_sub_calculos['LIQ_01'].de_61_90,
      data.liquidaciones_sub_calculos['LIQ_01'].de_91_180,
      data.liquidaciones_sub_calculos['LIQ_01'].de_181_360,
      data.liquidaciones_sub_calculos['LIQ_01'].mas_360,]
    },{
      id: 'LIQ_02',
      idEvaluacion: eva,
      bandas: [data.liquidaciones_sub_calculos['LIQ_02'].de_1_7,
      data.liquidaciones_sub_calculos['LIQ_02'].de_8_15,
      data.liquidaciones_sub_calculos['LIQ_02'].de_16_30,
      data.liquidaciones_sub_calculos['LIQ_02'].de_31_60,
      data.liquidaciones_sub_calculos['LIQ_02'].de_61_90,
      data.liquidaciones_sub_calculos['LIQ_02'].de_91_180,
      data.liquidaciones_sub_calculos['LIQ_02'].de_181_360,
      data.liquidaciones_sub_calculos['LIQ_02'].mas_360,]
    });
    this.getDataAsientos(datos, eva);
  }
  private async getDataAsientos(datos, eva){
    const data = await this.service.getAsientos(this.cadenaEvaluacion[0].an+'-'+FuncionesMes.f_switchmes3(this.cadenaEvaluacion[0].mes)+'-01');
    datos.push({
        id: 'ASI_01',
        idEvaluacion: eva,
        bandas: [ data.creditos_sub_calculos['ASI_01'].de_1_7,
        data.creditos_sub_calculos['ASI_01'].de_8_15,
        data.creditos_sub_calculos['ASI_01'].de_16_30,
        data.creditos_sub_calculos['ASI_01'].de_31_60,
        data.creditos_sub_calculos['ASI_01'].de_61_90,
        data.creditos_sub_calculos['ASI_01'].de_91_180,
        data.creditos_sub_calculos['ASI_01'].de_181_360,
        data.creditos_sub_calculos['ASI_01'].mas_360,]
      },{
        id: 'ASI_02',
        idEvaluacion: eva,
        bandas: [data.creditos_sub_calculos['ASI_02'].de_1_7,
        data.creditos_sub_calculos['ASI_02'].de_8_15,
        data.creditos_sub_calculos['ASI_02'].de_16_30,
        data.creditos_sub_calculos['ASI_02'].de_31_60,
        data.creditos_sub_calculos['ASI_02'].de_61_90,
        data.creditos_sub_calculos['ASI_02'].de_91_180,
        data.creditos_sub_calculos['ASI_02'].de_181_360,
        data.creditos_sub_calculos['ASI_02'].mas_360,]
      });
      await this.getAdicionales();
      this.getDataInversiones(datos, eva);
  }
  private async getAdicionales(){
    this.adicionales = [];
    for( var i=1; i<5; i++){
      const data = await this.service.getAditionals("2023-01-01", `editable_${i}`)
      const datos = data.creditos_sub_calculos.adicionales;
      var aux = [];
      for ( const dat of datos ) {
        const per = moment( dat.periodo.split('T')[0] ).format('YYYY-MM');
        const ex = aux.find( i => i.periodo === per);
        if( aux.length === 0 || !ex ){
          var por = [];
          for( const inf of opciones){
            por.push( dat.propiedades.ASI_01[inf].value );
          }
          aux.push({
            periodo: per,
            porcentaje: por,
            calculo: `editable_${i}`,
          });
        }
      }
      this.adicionales = [...this.adicionales, ...aux];
      this.adicionales.sort( function (a,b) {
        if ( moment(a.periodo, 'YYYY-MM').isAfter(moment(b.periodo, 'YYYY-MM') ) )
          return -1;
        if ( moment(a.periodo, 'YYYY-MM').isAfter(moment(b.periodo, 'YYYY-MM') ) )
          return 1;
        return 0;
      })
    }    
  }
  private async getDataInversiones(datos, eva){
    const data = await this.service.getInversiones(this.cadenaEvaluacion[0].an+'-'+FuncionesMes.f_switchmes3(this.cadenaEvaluacion[0].mes)+'-01');
    datos.push({
      id: 'INV_01',
      idEvaluacion: eva,
      bandas: [ data.inversiones_sub_calculos['INV_01'].de_1_7,
      data.inversiones_sub_calculos['INV_01'].de_8_15,
      data.inversiones_sub_calculos['INV_01'].de_16_30,
      data.inversiones_sub_calculos['INV_01'].de_31_60,
      data.inversiones_sub_calculos['INV_01'].de_61_90,
      data.inversiones_sub_calculos['INV_01'].de_91_180,
      data.inversiones_sub_calculos['INV_01'].de_181_360,
      data.inversiones_sub_calculos['INV_01'].mas_360,]
    },{
      id: 'INV_02',
      idEvaluacion: eva,
      bandas: [data.inversiones_sub_calculos['INV_02'].de_1_7,
      data.inversiones_sub_calculos['INV_02'].de_8_15,
      data.inversiones_sub_calculos['INV_02'].de_16_30,
      data.inversiones_sub_calculos['INV_02'].de_31_60,
      data.inversiones_sub_calculos['INV_02'].de_61_90,
      data.inversiones_sub_calculos['INV_02'].de_91_180,
      data.inversiones_sub_calculos['INV_02'].de_181_360,
      data.inversiones_sub_calculos['INV_02'].mas_360,]
    });
    this.getDataTabla(datos);
    this.getDataTablaComp(datos);
  }
  /* Variables Promedio */
  private getPromedio(esp){
    var val = 0
    for(var i=0; i<this.dataAllPromedio[0].valor.length; i++){
      val += this.calculosProm(esp.codigo, this.dataAllPromedio, i);
    }
    return val/this.dataAllPromedio[0].valor.length;
  }
  private getDataTabla(data){
    this.dataAllCuentas = data;
    var dataTabla = [], aux = [];
    for(var i = 1; ;i++){
      const dat = GAPRiesgos.tabla(this.idPlantilla,i);
      if(dat === undefined){
        break;
      }else{
        let esp = dat[0];
        if( esp.codigo !== 'suma'){
          var val = 0;
          if(esp.codigo !== ''){
            val = this.calculos(esp.codigo, data);
          }
          if(esp.prom){
            val = this.getPromedio(esp);
          }
          var name = esp.codigo !== '' ? this.nombres(esp.codigo, data, esp) ?? esp.descripcion : esp.descripcion;
          var ban = this.obtBandas(esp, val, data);
          aux.push({
            name: name,
            bandas: ban.bandas,
            codigo: esp.calculo,
            total: ban.tot,
            edit: esp.edit,
            eval: esp.eval,
            por: ban.por,
            idCuenta: esp.codigo,
            pos: i,
            manual: esp.ingresoManual,
            valBan: esp.valBan
          });
        }else{
          let bandas = [], tot=0;
          for(var j=0; j<esp.bandas.length; j++){
            var sum=null;
            for(const dat of aux){
              if(esp.bandas[j]===1 && (dat.bandas[j]!==undefined&&dat.bandas[j]!==null) ){
                sum += dat.bandas[j];
              }
            }
            tot+= sum;
            bandas.push(sum);
          }

          aux.push({
            name: '',
            bandas: bandas,
            total: tot,
            eval: esp.eval,
            idCuenta: esp.codigo,
            codigo:'suma',
            edit: esp.edit,
            manual: esp.ingresoManual,
            valBan: esp.valBan
          });
          dataTabla.push(aux);
          aux=[];
        }
      }
    }
    this.dataOrdenado = dataTabla;
    this.dataTablasTot();
  }
  private dataTablasTot(){
    var dataTabla = [], aux = [], sumAux = [];
    for(var i=1; ;i++){
      const dat = gap.tabTot(i);
      if(dat === undefined){
        break;
      }else{
        const data = dat[0];
        if(data.codigo === 'valor'){
          const valores = this.dataOrdenado[data.tabla][this.dataOrdenado[data.tabla].length-1];
          aux.push({
            name: data.name,
            bandas: valores.bandas,
            tot: null,
            edit: false,
            codigo: data.codigo
          });
          sumAux.push(valores.bandas)
        }else if(data.codigo === 'sumaPar'){
          var ban = [];
          for(var j=0; j<this.bandas.length;j++){
            var sum = 0;
            for(const dat of sumAux){
              sum +=dat[j];
            }
            if( data.name === 'Total de entradas'){
              ban.push(sum);// /1.6 Preguntar motivo del porque esta así
            }else{
              ban.push(sum);
            }
          }
          aux.push({
            name: data.name,
            bandas: ban,
            tot: null,
            edit: false,
            codigo: 'suma'
          });
          dataTabla.push(ban)
          sumAux = [];
        }else if(data.codigo === 'suma'){
          var ban = [], ban2=[], sumAcum=0;
          for(var j=0; j<this.bandas.length;j++){
            var sum = dataTabla[0][j]-dataTabla[1][j];
            sumAcum += sum;
            ban.push(sum);
            ban2.push(sumAcum);
          }
          aux.push({
            name: data.name,
            bandas: ban,
            tot: null,
            edit: false,
            codigo: data.codigo
          });
          aux.push({
            name: 'GAP acumulado',
            bandas: ban2,
            tot: null,
            edit: false,
            codigo: data.codigo
          });
        }
      }
    }
    const aux1 = [aux[0],aux[1],aux[2]]
    const aux2 = [aux[3],aux[4],aux[5]]
    const aux3 = [aux[6],aux[7]]
    this.dataOrdenado.push(aux1);
    this.dataOrdenado.push(aux2);
    this.dataOrdenado.push(aux3);
    this.dataTablaAct();
  }
  private dataTablaAct(){
    var bandas = [], aux = [];

    var valores = this.dataOrdenado[0][this.dataOrdenado[0].length-1];
    bandas.push(valores.bandas);
    aux.push({
      name: 'Activos liquidos',
      bandas: valores.bandas,
      tot: null,
      edit: false,
      codigo: ''
    });

    valores = this.dataOrdenado[this.dataOrdenado.length-1][this.dataOrdenado[this.dataOrdenado.length-1].length-1];
    var ban = [];
    for(const band of valores.bandas){
      if(band > 0){
        ban.push(Math.abs(0));
      }else{
        ban.push(Math.abs(band));
      }
    }
    bandas.push(ban);
    aux.push({
      name: 'Valor absoluto del GAP negativo',
      bandas: ban,
      tot: null,
      edit: false,
      codigo: ''
    });
    ban=[];
    var sum = 0, ban2 = [], ban3 = [], ban4 = [], ban5 = [];
    for(var i=0; i<this.bandas.length; i++){
      if(bandas[1][i] !== 0){
        if(bandas[0][i] !== null){
          sum += bandas[0][i];
        }
        if(sum >= bandas[1][i]){
          ban2.push('Cubierto con AL');
          ban3.push(null);
          ban4.push(null);
          ban5.push(null);
        }else{
          ban2.push('VRL');
          const inv = this.dataOrdenado[1][0];
          var valInv = 0;
          for(var j=i+1; j<inv.bandas.length; j++){
            if(inv.bandas[j] !== undefined && inv.bandas[j] !== null){
              valInv += inv.bandas[j];
            }
          }
          ban3.push(bandas[1][i]-sum);
          ban4.push(valInv);
          ban5.push(valInv/(bandas[1][i]-sum)*100);
        }
        ban.push(sum/bandas[1][i]*100);
      }else{
        if(bandas[0][i] !== null){
          sum += bandas[0][i];
        }
        ban.push(0);
        ban3.push(null);
        ban4.push(null);
        ban5.push(null);
        ban2.push('GAP positivo');
      }
    }
    aux.push({
      name: 'Activos líquidos / GAP negativo',
      bandas: ban,
      tot: null,
      edit: false,
      codigo: 'porcentaje'
    });
    aux.push({
      name: 'Estatus de liquidez',
      bandas: ban2,
      tot: null,
      edit: false,
      codigo: 'texto'
    });
    aux.push({
      name: 'Valor en riesgo por liquidez no cubierto por activos líquidos',
      bandas: ban3,
      tot: null,
      edit: false,
      codigo: ''
    });
    aux.push({
      name: 'Inversiones financieras acumuladas posteriores al GAP negativo',
      bandas: ban4,
      tot: null,
      edit: false,
      codigo: ''
    });
    aux.push({
      name: 'Cobertura con inversiones financieras acumuladas',
      bandas: ban5,
      tot: null,
      edit: false,
      codigo: 'porcentaje'
    });
    this.dataOrdenado.push(aux);
    this.dataTablaAnalisisEstres();
  }
  private dataTablaAnalisisEstres(){
    var b18 = this.dataOrdenado[1][1];
    var b20 = this.dataOrdenado[1][2];
    var b57 = this.dataOrdenado[3][0];
    var b86 = this.dataOrdenado[5][2];
    var b89 = this.dataOrdenado[6][2];

    var dat = 0, sum = 0, ban = [], ban2 = [], aux = [], res = 0;
    for(var i=0; i<this.bandas.length; i++){
      dat = (b86.bandas[i]-(b18.bandas[i]+b57.bandas[i])*(1-(this.maximoIng/100))-(b20.bandas[i]*(1-(this.porMax/100))))-b89.bandas[i];
      if(this.capAco && i ===3){
        res = this.dataOrdenado[2][0].bandas[4];
        dat += res;
      }else if(this.capAco && i ===4){
        res = this.dataOrdenado[2][0].bandas[4];
        dat -= res;
      }
      sum += dat;
      ban.push(dat);
      ban2.push(sum);
    }

    aux.push({
      name: 'Nuevo GAP por tramo',
      bandas: ban,
      tot: null,
      edit: false,
      codigo: 'suma'
    });
    aux.push({
      name: 'Nuevo GAP acumulado',
      bandas: ban2,
      tot: null,
      edit: false,
      codigo: 'suma'
    });
    this.dataOrdenado.push(aux);
    this.dataTablaActEstres();
  }
  private dataTablaActEstres(){
    var bandas = [], aux = [];

    var valores = this.dataOrdenado[0][this.dataOrdenado[0].length-1];
    bandas.push(valores.bandas);
    aux.push({
      name: 'Activos liquidos',
      bandas: valores.bandas,
      tot: null,
      edit: false,
      codigo: ''
    });

    valores = this.dataOrdenado[this.dataOrdenado.length-1][this.dataOrdenado[this.dataOrdenado.length-1].length-1];
    var ban = [];
    for(const band of valores.bandas){
      if(band > 0){
        ban.push(Math.abs(0));
      }else{
        ban.push(Math.abs(band));
      }
    }
    bandas.push(ban);
    aux.push({
      name: 'Valor absoluto del GAP negativo',
      bandas: ban,
      tot: null,
      edit: false,
      codigo: ''
    });
    ban=[];
    var sum = 0, ban2 = [], ban3 = [], ban4 = [], ban5 = [];
    for(var i=0; i<this.bandas.length; i++){
      if(bandas[1][i] !== 0){
        if(bandas[0][i] !== null){
          sum += bandas[0][i];
        }
        if(sum >= bandas[1][i]){
          ban2.push('Cubierto con AL');
          ban3.push(null);
          ban4.push(null);
          ban5.push(null);
        }else{
          ban2.push('VRL');
          const inv = this.dataOrdenado[1][0];
          var valInv = 0;
          for(var j=i+1; j<inv.bandas.length; j++){
            if(inv.bandas[j] !== undefined && inv.bandas[j] !== null){
              valInv += inv.bandas[j];
            }
          }
          ban3.push(bandas[1][i]-sum);
          ban4.push(valInv);
          ban5.push(valInv/(bandas[1][i]-sum)*100);
        }
        ban.push(sum/bandas[1][i]*100);
      }else{
        if(bandas[0][i] !== null){
          sum += bandas[0][i];
        }
        ban.push(0);
        ban3.push(null);
        ban4.push(null);
        ban5.push(null);
        ban2.push('GAP positivo');
      }
    }
    aux.push({
      name: 'Activos líquidos / GAP negativo',
      bandas: ban,
      tot: null,
      edit: false,
      codigo: 'porcentaje'
    });
    aux.push({
      name: 'Estatus de liquidez',
      bandas: ban2,
      tot: null,
      edit: false,
      codigo: 'texto'
    });
    aux.push({
      name: 'Valor en riesgo por liquidez no cubierto por activos líquidos',
      bandas: ban3,
      tot: null,
      edit: false,
      codigo: ''
    });
    aux.push({
      name: 'Inversiones financieras acumuladas posteriores al GAP negativo',
      bandas: ban4,
      tot: null,
      edit: false,
      codigo: ''
    });
    aux.push({
      name: 'Cobertura con inversiones financieras acumuladas',
      bandas: ban5,
      tot: null,
      edit: false,
      codigo: 'porcentaje'
    });
    this.dataOrdenado.push(aux);
  }
  private getDataTablaComp(data){
    var dataTabla = [], aux = [];
    for(var i = 1; ;i++){
      const dat = GAPRiesgos.tablaCom(this.idPlantilla,i);
      if(dat === undefined){
        break;
      }else{
        let esp = dat[0];
        if( esp.codigo !== 'suma' && esp.codigo !== ''){
          var val = this.calculos(esp.codigo, data);
          const name = this.nombres(esp.codigo, data, esp);
          let tot=val;
          
          aux.push({
            name: name,
            total: tot,
            edit: esp.edit,
            pos: i,
          });
        }else{
          var sum=0;
          for(const dat of aux){
            sum += dat.total
          }
          aux.push({
            name: '',
            total: sum,
            edit: esp.edit,
          });
          dataTabla.push(aux);
          aux=[];
        }
      }
    }
    this.dataOrdenadoComp = dataTabla;
  }
  public actualizarTablas2(valor?){
    if(valor!==undefined){
      this.capAco = !this.capAco;
    }
    this.maximoIng = Number(document.getElementById('maximoIng')["value"]);
    if(this.idPlantilla === 7){
      this.porMax = Number(document.getElementById('porMax')["value"]) ?? 0;
    }
    var dataTablaResp = []
    for(var i=0; i<9; i++){
      dataTablaResp.push(this.dataOrdenado[i]);
    }
    this.dataOrdenado=dataTablaResp;
    this.dataTablaAnalisisEstres();
  }
  /* Obtención de bandas */
  private obtBandas(esp, val, data){
    let bandas = [], tot=0, porcentajes = [];
    
    if(esp.valBan === undefined && Array.isArray(esp.calculo) ){
      for(var j=0; j<esp.bandas.length; j++){
        if(esp.bandas[j]===1){
          bandas.push(val*esp.calculo[j]);
          tot+=val*esp.calculo[j];
        }else{
          bandas.push(null);
        }
      }
      if(esp.edit){
        porcentajes = esp.calculo;
      }
    }else if (esp.valBan === undefined && !Array.isArray(esp.calculo)){
      if(this.idPlantilla === 7){
        const ex = this.adicionales.filter(ad => ad.calculo === esp.calculo);
        if (ex.length !== 0) {
          const per = moment( this.cadenaEvaluacion[0].evaluacion, 'MMM YY' );
          const a = ex.find( ad => moment(ad.periodo, 'YYYY-MM').isSameOrBefore(per, 'month') )
          if ( a ) {
            var i = 0;
            for ( const ban of esp.bandas) {
              var por = a.porcentaje[i];
              if ( ban === 1 ) {
                bandas.push(val*por);
                porcentajes.push(por);
              } else {
                bandas.push(null);
                porcentajes.push(null);
              }
              i++;
            }
            tot = val;
          }
        }
      }else{
        const bandasEdit = data.find(d => d.id === esp.calculo) ?? {bandas: this.bandas.map(i => {return 1/this.bandas.length})};
        
        for ( const ban of bandasEdit.bandas) {
          var por = ban;
          bandas.push(val*por);
          porcentajes.push(por);
        }
        tot = val;
      }
      
      if(bandas.length === 0) {
        for ( const ban of esp.bandas) {
          if ( ban === 1 ) {
            bandas.push(0);
            porcentajes.push(0);
          } else {
            bandas.push(null);
            porcentajes.push(null);
          }
        }
        tot = val;
      }
      
    }else{
      const per = this.periodos.map(a => { return a.series.find(m => m.check) }).find(e => e !== undefined);
      const valores = data.filter(item => 
        item.id === esp.valBan &&
        ( !esp.ingresoManual || 
          ( item.anio === per.an && item.mes === per.nmes ) 
        )
      );
      if(valores.length !== 0){
        valores[0].bandas.forEach( (ban, i) =>{
          bandas.push(esp.calculo[i]===1?ban:null);
          if(ban!== undefined){
            tot+=esp.calculo[i]===1?ban:null;
          }
        });
      }else{
        for(const ban of esp.bandas){
          bandas.push(0);
        }
      }
    }

    return {bandas: bandas, tot: tot, por: porcentajes}
  }
  private recalcularBandas(esp, val, data){
    let bandas = [], tot=0;
    if(esp.edit){  
      for(var i=0; i <val.length; i++){
        if(esp.bandas[i]!==null){
          bandas.push(data*esp.por[i]);
          tot+=data*esp.por[i];
        }else{
          bandas.push(null);
        }
      }  
    }else{

      val.forEach((ban, i) =>{
        bandas.push( esp.valBan === this.nameVar? ban: esp.bandas[i] );
          tot+= esp.valBan === this.nameVar? ban??0: Number(esp.bandas[i]);
      })
    }
    return {bandas: bandas, tot: tot}
  }
  private recalcularDataTabla(){
    var aux = [];
    for(const tabla of this.dataOrdenado){
      for(const elem of tabla){
        if(elem.idCuenta !== 'suma' && (elem.edit || elem.manual)){
          const value = elem.edit ? this.calculos(elem.idCuenta, this.dataAllCuentas):0;
          const val = this.recalcularBandas(elem,this.bandasValues,value);
          elem.bandas = val.bandas;
          elem.total = val.tot;
          aux.push(elem.bandas)
        }else if(elem.idCuenta !== 'suma'){
          aux.push(elem.bandas)
        }else if(elem.idCuenta === 'suma'){
          var bandas = [], tot = 0;
          for(var j=0; j<elem.bandas.length; j++){
            var sum=null;
            for(const dat of aux){
              if(elem.bandas[j]!==null && (dat[j]!==undefined && dat[j]!==null) ){
                sum += dat[j];
              }
            }
            tot+= sum;
            bandas.push(sum);
          }
          elem.bandas = bandas;
          elem.total = tot;
          aux = [];
        }
      }
    }
    var dataTablaResp = []
    for(var i=0; i<5; i++){
      dataTablaResp.push(this.dataOrdenado[i]);
    }
    this.dataOrdenado=dataTablaResp;
    this.dataTablasTot();
  }
  /* Obtención de datos */
  private nombres(formula, variables, esp){
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables.filter( valor => valor.id === elements[0])[0];
      return this.capitalizacionTexto(valor.descripcion);
    }
    return esp.descripcion; 
  }
  private calculos(formula, variables){
    if(formula.includes('+') && formula.includes('/')){
      const form = formula.split(' + ');
      if(form.length === 2){
        const val1 = this.calculos(form[0], variables);
        const val2 = this.calculos(form[1], variables);
        return val1+val2;
      }      
    }
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables.filter( valor => valor.id === elements[0])[0];
      return valor.valor;
    }
    let val1=null, val2=null, signo = '';
    for(const elem of elements){
      if(val1===null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        val1 = valor.valor;
      }else if(signo === ''){
        signo = elem;
      }else if(val2 === null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        if(valor !== undefined){
          val2 = valor.valor;
        }else if(valor === undefined && elem === 'V050'){
          for(const an of this.periodos){
            for(const mes of an.series){
              if(mes.check){
                val2 = Number(FuncionesMes.f_switchmes3(mes.mes));
              }
            }
          }
        }
        switch(signo){
          case '/':
            val1 = val1/val2;
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1*val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1+val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1-val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(val1.toFixed(1)); 
  }
  private calculosProm(formula, variables, pos){
    if(formula.includes('+') && formula.includes('/')){
      const form = formula.split(' + ');
      if(form.length === 2){
        const val1 = this.calculosProm(form[0], variables, pos);
        const val2 = this.calculosProm(form[1], variables, pos);
        return val1+val2;
      }      
    }
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables.filter( valor => valor.id === elements[0])[0];
      return valor.valor[pos];
    }
    let val1=null, val2=null, signo = '';
    for(const elem of elements){
      if(val1===null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        val1 = valor.valor[pos];
      }else if(signo === ''){
        signo = elem;
      }else if(val2 === null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        if(valor !== undefined){
          val2 = valor.valor[pos];
        }else if(valor === undefined && elem === 'V050'){
          for(const an of this.periodos){
            for(const mes of an.series){
              if(mes.check){
                val2 = Number(FuncionesMes.f_switchmes3(mes.mes));
              }
            }
          }
        }
        switch(signo){
          case '/':
            val1 = val1/val2;
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1*val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1+val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1-val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(val1.toFixed(1)); 
  }
  /* acciones en filtros */
  public cambioPeriodo(per){
    for(const an of this.periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }
  /* Funciones de tabla */
  public mostrarPorcentajes(dat){
    this.bandasValues = [];
    if(dat !== undefined){
      this.idEdit = dat;
      this.bandasValues = this.bandas.map((_, index) => {
        const valor = dat.por?.[index];
        return valor === undefined ? 0 : valor;
      });
      var aux = [], sum = 0;
      for(const val of this.bandasValues){
        if(val !== null){
          aux.push(val*100);
          sum += val*100;
        }else{
          aux.push(null);
        }
      }
      this.bandasValues = aux;
      this.totalPorcen = this.formaterPipe.transform(sum,0,',','.');
      this.tituloEdit = dat.name;
      this.modal = true;
    }
  }
  public closeModal(){
    this.modal = false;
  }
  public async guardarPorcentajes(){
    let aux = [], i = 0;
    for(const val of this.bandasValues){
      if(val !== null){
        const valorN = Number(document.getElementById('valor'+i)["value"].replace(/,/g, ''));
        aux.push(valorN);
      }else{
        aux.push(null);
      }
      i++;
    }
    let suma = 0;
    for(const val of aux){
      suma += val;
    }
    if(suma === 100){
      this.bandasValues = [];
      this.idPlantilla === 7 ? this.postPorcentaje(aux) : this.posteditableRiesgo(aux, this.idEdit.codigo, this.idEdit.manual);
    }else{
      messages.errorMessageGraph('Los porcentajes deben sumar el 100%');
    }
  }
  private async postPorcentaje(datos){
    var ban = "", i = 0, aux = datos;
    for(const val of aux){
      var coma = ', ';
      if(i === aux.length-1){
        coma = '';
      }
      if(val !== null){
        ban += `"${opciones[i]}": { "value": ${val/100} }${coma}`;
        this.bandasValues.push(val/100);
      }else{
        ban += `"${opciones[i]}": { "value": null }${coma}`;
        this.bandasValues.push(null);
      }
      i++;
    }
    var per = moment(this.cadenaEvaluacion[0].evaluacion, 'MMM YY').format('YYYY-MM-DD');
    ban = `{"periodo": "${per}", "propiedades": { "ASI_01": { ${ban} } }, "subColeccion": "${this.idEdit['codigo']}", "institucionId":  "6463f46b5a452a0012fa8f38"}`;
    await this.service.postAdicionales(ban);
    await this.getAdicionales();
    for(const tab of this.dataOrdenado){
      for(const elem of tab){
        if(elem.pos === this.idEdit['pos']){
          elem.por = JSON.parse(JSON.stringify(this.bandasValues));
          break;
        }
      }
    }
    messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    this.recalcularDataTabla();
    this.closeModal();
  }
  private async posteditableRiesgo(datos, name, manual){
    try{
      this.bandasValues = [];
      const d = {
        idInstitucion: this.idAdmin,
        anio: Number(this.cadenaEvaluacion[0].an),
        mes: Number( this.cadenaEvaluacion[0].mesNum),
        nombre: name
      }
      var bandas = [];
      for(var i = 0; i < this.bandas.length; i++){
        this.bandasValues.push(!manual ? datos[i]/100 : datos[i]);
        bandas.push({
          label: this.bandas[i],
          valor: !manual ? datos[i]/100 : datos[i],
          order: i+1
        })
      }
      await firstValueFrom(this.service.postVariblesGapRiesgos(d,bandas))
      for(const tab of this.dataOrdenado){
        for(const elem of tab){
          if(elem.pos === this.idEdit['pos']){
            !manual ? elem.por = this.bandasValues: elem.bandas = this.bandasValues;
            break;
          }
        }
      }
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.recalcularDataTabla();
      this.closeModal();
    }catch(e){
      messages.errorMessageGraph(e);
      this.closeModal();
    }
  }
  public cancelPorcentajes(){
    var i = 0;
    for(const val of this.idEdit.bandas){
      if(val !== 0 && val !== null){
        this.bandasValues[i] = val;
      }
      i++;
    }
    this.obtenerTotalPorcentajes();
  }
  public actualizarBanda(indice: number, valor: number | null){
    this.bandasValues[indice] = valor ?? 0;
    this.obtenerTotalPorcentajes();
  }
  public seleccionarCero(event: FocusEvent){
    const input = event.target as HTMLInputElement;

    // if (input.value === '0') {
      input.select();
    // }
  }
  public obtenerTotalPorcentajes(){
    var aux = [], i=0;
    for(const val of this.bandasValues){
      if(val !== null){
        const valorN = Number(document.getElementById('valor'+i)["value"].replace(/,/g, ''));
        aux.push(valorN);
      }else{
        aux.push(null);
      }
      i++;
    }
    let suma = 0;
    for(const val of aux){
      suma += val;
    }
    this.totalPorcen = this.formaterPipe.transform(suma,0,',','.');
  }
  /* Icono */
  public mostrarIcon(numTab, pos){
    if(numTab!==9 && numTab!==7 && pos === this.dataOrdenado[numTab].length-1){
      return true
    }
    return false;
  }
  /* Funciones de formateo */
  formato = '';
  public formNum(num, dec){
    if(num !== undefined && num !== '' && num !== null){
      switch(this.formato){
        case 'miles':
          num = Math.trunc(num/1000);
          break;
        case '':
          num = Math.trunc(num);
          break;
      }
    }
    if (num !== undefined && num !== '' && num !== null){
      return CommonVariables.formatearMoneda(Math.abs(num), dec, this.miles, this.decimal);
    }
    return '';
  }
  /* formateo de datos */
  public escrituraPer(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  /* Exortar */
  public exportExcel(){
    let headers = [this.translate.instant('liquidez.gap.tituloTabla3'),this.translate.instant('liquidez.gap.tituloTabla4')];
    for(const ban of this.bandas){
      headers.push(this.translate.instant('liquidez.gap.tituloTabla3'));
    }
    let headers2 = [this.translate.instant('liquidez.gap.tituloTabla3')];
    for(const ban of this.bandas){
      var tx = this.idPlantilla == 7 ? this.translate.instant('liquidez.gap.'+ban) : ban
      headers2.push(tx);
    }
    headers2.push(this.translate.instant('liquidez.gap.tituloTabla2'));
    let datos = [], aux = [],t=0;
    for(const tab of this.dataOrdenado){
      let d = 0;
      if(t===0 || t===5 || t>7){
        datos.push(['-' + this.translate.instant('liquidez.gap.titSec' + t),...Array(this.bandas.length + 1).fill('')]);
      }
      if(t===8){
        datos.push(['-'+this.translate.instant('liquidez.gap.titSec11'),...Array(this.bandas.length + 1).fill('')]);
      }
      for(const item of tab){
        if(item.name.includes('GAP por tramo') || item.name.includes('GAP acumulado')){
          aux.push(item.name!==''?'-'+item.name:'Total');
        }else{
          aux.push(item.name!==''?item.name:'Total');
        }
        for(const ban of item.bandas){
          aux.push(ban!==null&&ban!==undefined?ban:'');
        }
        aux.push(item.total!==null&&item.total!==undefined?item.total:'');
        datos.push(aux);
        aux = [];
        d++;
      }
      datos.push(['','','','','','','','','','']);
      t++;
    }

    let titulo = this.translate.instant('liquidez.gap.tituloTabla') + ' | ' + this.escrituraPer(this.subTitles);
    this.excelService.generateGAP(titulo, headers, headers2, datos, this.translate.instant('liquidez.gap.tituloTabla') + ' ' + this.escrituraPer(this.subTitles));
  }
  public capitalizacionTexto(text){
    if(!text) return;
    var mayuscula = text.substring(0,1).toUpperCase();
    if (text.length > 0) {
      var minuscula = text.substring(1).toLowerCase();
      if(minuscula[minuscula.length-1] === '.'){
        minuscula = minuscula.substring(0,minuscula.length-1);
      }
    }
    const textF = mayuscula.concat(minuscula);
    return textF;
  }
  public mostrarEditables(dat, nameVar){
    this.bandasValues = [];
    if(dat !== undefined){
      this.idEdit = dat;
      this.nameVar = nameVar;
      // this.bandasValues = this.bandas.map((_, index) => dat.bandas?.[index] ?? 0);
      this.bandasValues = this.bandas.map((_, index) => {
        const valor = dat.bandas?.[index];
        return valor === undefined ? 0 : valor;
      });
      var aux = [], sum = 0;
      for(const val of this.bandasValues){
        if(val !== null){
          aux.push(val);
          sum += val;
        }else{
          aux.push(null);
        }
      }
      this.bandasValues = aux;
      this.totalPorcen = this.formaterPipe.transform(sum,0,',','.');
      this.tituloEdit = dat.name;
      this.modal = true;
    }
  }
  public async guardarVariables(){
    let aux = [], i = 0;
    for(const val of this.bandasValues){
      if(val !== null){
        const valorN = Number(document.getElementById('valor'+i)["value"].replace(/,/g, ''))??0;
        aux.push(valorN);
      }else{
        aux.push(null);
      }
      i++;
    }
    this.posteditableRiesgo(aux, this.nameVar, this.idEdit.manual);
  }
}
